import { Box, Icon, Image, ImageProps } from '@chakra-ui/react'
import { OpenEye } from '@root/assets/admin'
import { CenterFlex } from '@root/components/dashboard/chat/style'
import { useTranslation } from 'react-i18next'

interface IViewableImage {
    url:any,
    onClick?:any,
    imagesProps?:ImageProps
}

export const ViewableImage = ({ url, onClick = () => null, imagesProps }: IViewableImage) => {
    const { t } = useTranslation('common')
    if (!url) {
        return null
    }
    
    return (
        <Box
            position={'relative'}
            width={'fit-content'}
            my={'16px'}
        >
            <Image
                border={'1px solid'}
                borderColor={'gray.border'}
                width={'152px'}
                borderRadius={'8px'}
                height={'96px'}
                fallback={<Icon />}
                src={url}
                alt={t('adminQueryDrawer.imageAttached')}
                {...imagesProps}
            />
            <CenterFlex
                // @ts-ignore
                onClick={onClick}
                width={'24px'}
                height={'24px'}
                borderRadius={'50%'}
                bg={'theme.bg.box'}
                position={'absolute'}
                top={'10px'}
                right={'10px'}
                cursor={'pointer'}
            >
                <OpenEye
                    width={'10px'}
                    height={'10px'}
                />
            </CenterFlex>
        </Box>
    )
}
